import { useParams } from "react-router-dom";
import styles from "./styles.module.css";
import { projectData } from "../../Data/siteData";

const titleReplacements = {
  overview: "Overview",
  features: "Key Features",
  investment: "Investment Highlights",
  environmentalimpact: "Environmental and Social Impact",
  whyus: "Why Invest",
  projectdetails: "Project Details",
  contact: "Contact Us",
  gallery: "Project Gallery",
};

const improveTitle = (text, proName = "") => {
  const key = text.toLowerCase();
  if (key === "whyus" && proName) return `Why Invest in ${proName}?`;
  return titleReplacements[key] || text;
};

const RenderField = ({ label, value, proName }) => (
  <div className={styles.section}>
    <h3>{improveTitle(label, proName)}</h3>
    {Array.isArray(value) ? (
      label.toLowerCase() === "gallery" ? (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "16px", marginTop: "16px" }}>
          {value.map((img, index) => (
            <img key={index} src={img} alt={`Gallery ${index + 1}`} style={{ width: "100%", height: "auto", borderRadius: "8px" }} />
          ))}
        </div>
      ) : (
        <ul>
          {value.map((item, index) => (
            <li key={index}>
              {item.key ? (
                <>
                  <strong>{item.key}:</strong> {item.value}
                </>
              ) : (
                item
              )}
            </li>
          ))}
        </ul>
      )
    ) : typeof value === "object" && value !== null ? (
      Object.entries(value).map(([k, v], idx) => (
        <RenderField key={idx} label={k} value={v} proName={proName} />
      ))
    ) : (
      <p>{value}</p>
    )}
  </div>
);

const ProjectDetails = () => {
  const { name } = useParams();

  const myPro =
    projectData.find(
      (pd) => pd.proName.toLowerCase().replaceAll(" ", "-") === name
    ) || null;

  if (!myPro) return <p>Project not found.</p>;

  const { proName, tagLine, image, topList, ...restSections } = myPro;

  return (
    <div className={`about-container ${styles.portfolioPage}`}>
      <div className={`content ${styles.content}`}>
        <div className={styles.top}>
          <div className={styles.left}>
            <h1>{proName}</h1>
            <h4>{tagLine}</h4>
            <div className={styles.topList}>
              {topList?.map((item, i) => (
                <RenderField key={i} label={item.key} value={item.value} proName={proName} />
              ))}
            </div>
          </div>
          <div className={styles.image}>
            <img src={image} alt={proName} />
          </div>
        </div>
        {Object.entries(restSections).map(([key, value], i) => (
          <RenderField key={i} label={key} value={value} proName={proName} />
        ))}
      </div>
    </div>
  );
};

export default ProjectDetails;
